import { AppConfig } from 'src/app/core/_config/app.config';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FileModalBilletsService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    getBilletsByResponsible(responsibleId: any, params: any): Observable<any> {
        return this.http.get<ResponseCustom>(`${this.API_URL}Billets/Responsible/${responsibleId}`, params);
    }
}
